import React from 'react';
import { Loader2 } from 'lucide-react';

// Centered spinner for a page or panel that is loading (FECOA-2174).
const PageLoader = ({ label = 'Loading', className = 'min-h-[50vh]' }) => (
  <div className={`flex items-center justify-center ${className}`} role="status">
    <Loader2 className="h-7 w-7 animate-spin text-primary-600 dark:text-primary-400" aria-hidden="true" />
    <span className="sr-only">{label}</span>
  </div>
);

export default PageLoader;
